export default {
  authMessage: 'Please Login first to continue.',
  errorMessage: 'Something went wrong, please navigate to our contact us page to find the relevant contact information!',
  errorMessageDublicate: 'Please notice that identical booking has been detected and therefore no booking can be placed, for further information please contact us',
  errorMessageValidationOPUS: 'The card number that was entered is blocked. Please enter a valid number.',
  errorMessageValidationName: 'First and Last Name Fields can not contain any special characters',
  errorMessageCodeError: 'Code is incorrect. Please try again.',
  paymentDescription: 'Payment mode will be checked by the driver on board.', 
  note: {
    label: 'Notes',
    content: 'Content',
  }
};
